<template>
  <div class="provider-page">
    <BContainer class="bg-provider-page" fluid v-if="provider">
      <div class="map_provider">
        <ProviderMapHeader :scale-to="scaleMap" :center-to="centerMap" :countries="countries_id" />
      </div>
      <div class="container provider-page__header pl-3">
        <BRow>
          <BCol cols="12" md="5" class="justify-content-center provider-intro" v-if="provider.players">
            <div class="text-center text-md-left">
              <h1>{{ translateProvider(provider.provider_id) }}</h1>
              <CustomSharingOptions class="mt-3 mb-3" :title="`${$t('social.provider')} ${provider.provider}`" />
              <p class="excerpt mb-3">
                <span v-html="providerDesc(provider.provider_id)"></span>
              </p>
            </div>
            <div class="d-sm-block d-md-none text-center">
              <IconArrowDown :width="48" :height="48" />
            </div>
          </BCol>
        </BRow>
      </div>
    </BContainer>
    <BContainer v-if="provider && listRegions" ref="bg-provider-players" class="container bg-provider-players" fluid>
      <BRow class="float-filter d-block d-sm-block d-md-none">
        <BCol cols="12" class="pb-5">
          <b-button variant="primary" block class="mt-3"  v-b-modal.modal-menu>
           <IconCompass />  {{ $t('list.exploreBy') }}
          </b-button>
        </BCol>
      </BRow>
      <BRow>
        <BCol cols="12" md="3" class="d-none d-sm-none d-md-block mb-5 text-left">
          <div class="countries_filter">
            <div class="label mb-3">{{ provider.provider }} {{ $t('list.providerFilterLabel') }} :</div>
            <BFormGroup>
              <BFormRadioGroup
              id="btn-radios-regions"
              :options="listRegions"
              name="radio-btn-stacked"
              v-model="selectedRegion"
              buttons
              stacked />
            </BFormGroup>

            <div class="text-center btn-regions mt-5 mb-5">
              <b-dropdown block size="lg" menu-class="w-100" variant="dark">
                <template #button-content>
                  <IconSecrecyBroker class="mr-2" />  {{ $t('list.brokersLabel') }}
                </template>
                <b-dropdown-item-button v-for="provider_item in allProviders" :key="`region_${provider_item.provider_id}`">
                  <RouterLink class="d-block w-100 text-center" :to="{ name: 'provider.page', params: { provider_id: provider_item.provider_id } }">{{ translateProvider(provider_item.provider_id) }}</RouterLink>
                  </b-dropdown-item-button>
              </b-dropdown>
            </div>

            <AboutLinks />
          </div>
        </BCol>
        <BCol cols="12" md="8" offset-md="1" class="mb-5">
          <h3>{{ translateRegion(selectedRegion) }}</h3>
          <PlayersGrid :players="filteredPlayers" class="m-0 mb-5 p-0" />
        </BCol>
      </BRow>

    </BContainer>

    <b-modal ref="modal-menu-region" hide-footer id="modal-menu">
      <template #modal-title>
        <IconCompass /> {{ $t('list.exploreBy') }}
      </template>
      <div class="countries_filter">
        <BFormGroup>
          <BFormRadioGroup
          id="btn-radios-regions-mobile"
          :options="listRegions"
          name="radio-btn-stacked"
          v-model="selectedRegion"
          buttons
          stacked />
        </BFormGroup>
      </div>
    </b-modal>
  </div>
</template>


<script>
  import filter from 'lodash/filter'
  import utilsMixins from '@/mixins/utils'
  import providerMixins from '@/mixins/provider'
  import ProviderMapHeader from '@/components/ProviderMapHeader.vue'

  import CustomSharingOptions from '@/components/CustomSharingOptions.vue'
  import PlayersGrid from '@/components/PlayersGrid.vue'
  import AboutLinks from '@/components/AboutLinks.vue'
  import IconSecrecyBroker from '@/components/IconSecrecyBroker'
  import IconCompass from '@/components/IconCompass'
  import IconArrowDown from '@/components/IconArrowDown'

  export default {
    name: 'Provider',
    mixins: [providerMixins, utilsMixins],
    components: {
      AboutLinks,
      CustomSharingOptions,
      PlayersGrid,
      ProviderMapHeader,
      IconCompass,
      IconArrowDown,
      IconSecrecyBroker
    },
    data() {
      return {
        selectedRegion: 'all',
        centerMap: [0,0],
        scaleMap: 320
      }
    },
    mounted() {
      this.selectedRegion = `all`
    },
    watch: {
      selectedRegion() {
        if(this.$refs['bg-provider-players']) {
          const top = this.$refs['bg-provider-players'].offsetTop - 150
          window.scrollTo(0,top)
        }
        this.$refs['modal-menu-region'].hide()
      }
    },
    computed: {
      filteredPlayers() {
        if(this.provider && this.selectedRegion == 'all')
          return this.provider.players
        else if(this.provider && this.selectedRegion != 'all') {
          return filter(this.provider.players, ['region_id', this.selectedRegion])
        }
        else
          return []
      }
    }
  }

</script>

<style lang="scss">
  .map_provider {
    position: absolute;
    top: 0;
    width: 100%;
  }

  .float-filter {
    position: sticky;
    top: 88vh;
    z-index: 990;
  }

  .provider-page {
    .provider-intro {
      border-right: dashed 1px #fff;
    }

    h1 {
      font-size: 71px;

      @media (max-width: 768px) {
        font-size: 41px;
      }
    }

    .legend-map {
      position: absolute;
      bottom: 0;
      left: 15%;
      display: inline;
      font-weight: 900;
      padding: 5px 10px;
      color: var(--app-color-light);
      background-color: var(--app-color-red);
    }

    .excerpt {
      font-size: 21px;
      line-height: 1.5em;
    }

    
    &__header {
      color: var(--app-color-black);

      @media (max-width: 768px) {
        margin-top: 25vh;
      }
    }
  }

  .countries_filter {
    position: sticky;
    top: 85px;
    min-height: 70vh;

    span {
      font-size: 14px;
    }

    label {
      margin-bottom: 5px;
      text-transform: uppercase;
    }

    .router-link-active {
      color: var(--app-color-dark);
    }

    .btn-group-vertical {
      width: 100% !important;
    }

    .btn {
      display: inline-block !important;

      &.active {
        background: var(--app-color-red) !important;
      }
    }

    .btn-secondary {
      margin-bottom: 5px !important;
      color: #000;
      background: #1d1d1d30;
      border: none;
    }

    .btn-group-toggle {
      width: 100%;
    }
  }

  .bg-provider-page {
    padding: 5vh 0;
    color: #fff;
  }

  .bg-provider-players {
    h3 {
      text-transform: uppercase;
      color: var(--app-color-black);
      margin-bottom: 25px;
    }
  }
</style>
